// src/mobile/fab.ts
import {
  EventManager,
  setupEventListenersIfNeeded,
  WILDCARD_ACTION_ID,
} from './event-manager';
import { FloatingActionButtonConfig } from './types';
import { postJsMessage } from '../../../bridge';
import API from '../../../api';
import { isAvailable } from 'jssdk/utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * mobile.setFloatingActionButtonConfig
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    NotSupport
 * linux      NotSupport
 * ios        6.5.0
 * android    6.5.0
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function setFloatingActionButtonConfig(
  config: FloatingActionButtonConfig
): Promise<NativeAPIResponseMessage<unknown>> {
  await isAvailable('mobile.setFloatingActionButtonConfig');
  setupEventListenersIfNeeded();

  if (config.onTap) {
    // Cleanup previous callback
    EventManager.getInstance().unregisterCallback(
      'onFloatingActionButtonClick',
      WILDCARD_ACTION_ID
    );

    EventManager.getInstance().registerCallback(
      'onFloatingActionButtonClick',
      WILDCARD_ACTION_ID,
      config.onTap
    );
    delete config.onTap;
  }

  return postJsMessage(API.setFloatingActionButtonConfig, config);
}
